import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const MastercardMedium = (props: FlagsSvgProps) => {
  return (
    <Svg width={48} height={32} viewBox="0 0 48 32" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_4024" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z"
        fill="white"
      />
      <Path
        d="M4 0V1H44V0V-1H4V0ZM48 4H47V28H48H49V4H48ZM44 32V31H4V32V33H44V32ZM0 28H1V4H0H-1V28H0ZM4 32V31C2.34315 31 1 29.6569 1 28H0H-1C-1 30.7614 1.23858 33 4 33V32ZM48 28H47C47 29.6569 45.6569 31 44 31V32V33C46.7614 33 49 30.7614 49 28H48ZM44 0V1C45.6569 1 47 2.34315 47 4H48H49C49 1.23858 46.7614 -1 44 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_4024)"
      />
      <Path
        d="M28.4422 8.13794H19.5576V23.8619H28.4422V8.13794Z"
        fill="#FF5F00"
      />
      <Path
        d="M20.1222 15.9998C20.1208 14.4854 20.4692 12.9906 21.1411 11.6285C21.813 10.2664 22.7908 9.0727 24.0004 8.13776C22.5025 6.97821 20.7035 6.25711 18.8091 6.05687C16.9148 5.85663 15.0014 6.18532 13.2878 7.00539C11.5741 7.82546 10.1293 9.10382 9.1185 10.6943C8.10769 12.2849 7.57166 14.1234 7.57166 15.9998C7.57166 17.8761 8.10769 19.7146 9.1185 21.3052C10.1293 22.8957 11.5741 24.1741 13.2878 24.9941C15.0014 25.8142 16.9148 26.1429 18.8091 25.9426C20.7035 25.7424 22.5025 25.0213 24.0004 23.8618C22.7908 22.9268 21.813 21.7331 21.1411 20.371C20.4692 19.0089 20.1208 17.5141 20.1222 15.9998Z"
        fill="#EB001B"
      />
      <Path
        d="M40.4286 15.9998C40.4286 17.8761 39.8927 19.7146 38.8819 21.3051C37.8712 22.8957 36.4264 24.174 34.7128 24.9941C32.9992 25.8142 31.0858 26.1429 29.1915 25.9426C27.2972 25.7424 25.4982 25.0213 24.0004 23.8617C25.2089 22.9259 26.1859 21.732 26.8577 20.3701C27.5295 19.0082 27.8785 17.5138 27.8785 15.9998C27.8785 14.4857 27.5295 12.9913 26.8577 11.6294C26.1859 10.2675 25.2089 9.07364 24.0004 8.13776C25.4982 6.97821 27.2972 6.25711 29.1915 6.05687C31.0858 5.85663 32.9992 6.18533 34.7128 7.00541C36.4264 7.82549 37.8712 9.10385 38.8819 10.6944C39.8927 12.2849 40.4286 14.1234 40.4286 15.9998Z"
        fill="#F79E1B"
      />
      <Path
        d="M39.4597 22.1967V21.8748H39.5915V21.8092H39.2559V21.8748H39.3877V22.1967H39.4597ZM40.1114 22.1967V21.8085H40.0085L39.8902 22.0755L39.7718 21.8085H39.6688V22.1967H39.7415V21.9039L39.8525 22.1563H39.9278L40.0388 21.9033V22.1967H40.1114Z"
        fill="#F79E1B"
      />
    </Svg>
  )
}
